/**
 * Constantes globais nao-visuais do app.
 * Strings de copy juridica/privacidade ficam em src/features/privacy/privacyCopy.ts (T02).
 */
export const APP_NAME = "Diagnostico de Jornada Pontotel";
export const APP_TAGLINE =
  "Analise local de AFD/AEJ. Os arquivos nao saem do seu navegador.";

/** Versao do contrato de relatorio anonimo. Bumpada quando o payload muda. */
export const ANONYMOUS_REPORT_SCHEMA_VERSION = "0.1.0";

/** Tolerancias default usadas quando o usuario nao informa premissas. */
export const DEFAULT_TOLERANCE_MINUTES = 10;
export const DEFAULT_NIGHT_HOUR_START = 22;
export const DEFAULT_NIGHT_HOUR_END = 5;

/** Jornada padrão de trabalho (CLT 44h/sem, 8h/dia segunda a sexta). */
export const DEFAULT_DAILY_HOURS = 8;
/** Horas mensais previstas (220h é o padrão usado para cálculo de valor-hora a partir da folha). */
export const DEFAULT_MONTHLY_HOURS = 220;
/** Limite default para sinalizar jornada excessiva (10h/dia). */
export const DEFAULT_EXCESSIVE_JOURNEY_MINUTES = 600;
/** Intervalo intrajornada mínimo padrão (CLT 1h pra jornada > 6h). */
export const DEFAULT_INTRADAY_BREAK_MINUTES = 60;
/** Interjornada mínima padrão (CLT 11h). */
export const DEFAULT_INTERJOURNEY_MINUTES = 660;
/** Tempo médio estimado por correção manual (input + revisão). */
export const DEFAULT_CORRECTION_MINUTES_PER_EVENT = 5;
/**
 * Minutos de almoço pré-assinalado descontados quando o colab tem ≤2 batidas
 * no dia. Padrão 0 (não desconta). Empresas CLT que não exigem batida de
 * almoço normalmente configuram 60.
 */
export const DEFAULT_PRE_ASSIGNED_LUNCH_MINUTES = 0;
